exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination-container[data-v-72233bcd] {\r\n  background: #fff;\r\n  padding: 0px 2px;\n}\n.pagination-container.hidden[data-v-72233bcd] {\r\n  display: none;\n}\r\n", ""]);

// exports
